import ONotice from './index.vue';

ONotice.install = app => {
  app.component(ONotice.name, ONotice);
};

export default ONotice;
